<script>
import Datepicker from 'vuejs-datepicker'

export default {
  components: {
    Datepicker,
  },
  data() {
    return {
      dateRange: [
        {
          from: '',
          to: '',
        },
      ],
    }
  },
  methods: {
    addDateRange() {
      this.dateRange.push({
        from: '',
        to: '',
      })
    },
    addDataPoints(index) {
      this.$emit('add-data-points', this.dateRange[index])
    },
    exportDataPoints() {
      this.$emit('export-data-points')
    },
  },
}
</script>

<template>
  <div>
    <div class="text-lg mb-3 pl-4">Select a Date Range</div>
    <div v-for="(date, index) in dateRange" :key="index" class="flex mb-5">
      <div class="w-70">
        <BaseFormGroup id="startDate">
          <div class="relative">
            <Datepicker
              v-model="date.from"
              input-class="border cursor-pointer input border-gray-light focus:border-gray"
            />
            <span
              class="absolute inset-y-0 right-0 flex items-center mr-4 pointer-events-none"
            >
              <BaseIcon name="calendar" class="text-blue" :size="22" />
            </span>
          </div>
        </BaseFormGroup>
      </div>
      <div class="w-70 ml-3">
        <BaseFormGroup id="endDate">
          <div class="relative">
            <Datepicker
              v-model="date.to"
              input-class="border cursor-pointer input border-gray-light focus:border-gray"
            />
            <span
              class="absolute inset-y-0 right-0 flex items-center mr-4 pointer-events-none"
            >
              <BaseIcon name="calendar" class="text-blue" :size="22" />
            </span>
          </div>
        </BaseFormGroup>
      </div>
      <button
        class="button primary-button h-9.5 leading-relax text-lg rounded-small-button px-4 ml-2"
        @click="() => addDataPoints(index)"
      >
        Go
      </button>
    </div>
    <div class="flex justify-between">
      <button class="text-blue pl-4" @click="addDateRange">
        + Add Date Range
      </button>
      <button
        class="button primary-button h-9.5 leading-relax text-lg rounded-small-button px-4 ml-2"
        @click="exportDataPoints"
      >
        Export
      </button>
    </div>
  </div>
</template>
